import CategoriesList from "./features/CategoriesList";
import CompetitionsList from "./features/CompetitionsList";
import FinalResultsView from "./features/FinalResultsView";
import ScheduleDayPage from "./features/schedule/ScheduleDayPage";
import ScheduleGate from "./features/schedule/ScheduleGate";
import ScheduleList from "./features/schedule/ScheduleList";
import SchedulePositionPage from "./features/schedule/SchedulePositionPage";
import firebaseConfig from "./firebase";
import ResultsView from "./features/ResultsView";
import Root from "./components/core/Root";
import RoundsList from "./features/RoundsList";
import Theme from "./theme/theme";
import { CategoryContextProvider } from "./contexts/CategoryContext";
import { CompetitionContextProvider } from "./contexts/CompetitionContext";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";
import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { RoundContextProvider } from "./contexts/RoundContext";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";

export const app = initializeApp(firebaseConfig, "results");
export const db = getFirestore(app);

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Root />,
      children: [
        {
          index: true,
          element: <CompetitionsList />,
        },
        {
          path: ":competitionId/schedule",
          element: <ScheduleGate />,
        },
        {
          path: ":competitionId/schedule-list",
          element: <ScheduleList />,
        },
        {
          path: ":competitionId/schedule/:scheduleId",
          element: <ScheduleDayPage />,
        },
        {
          path: ":competitionId/schedule/:scheduleId/position/:positionId",
          element: <SchedulePositionPage />,
        },
        {
          path: ":competitionId/categories",
          element: (
            <CompetitionContextProvider>
              <CategoriesList mode="rounds" />
            </CompetitionContextProvider>
          ),
        },
        {
          path: ":competitionId/final-results",
          element: (
            <CompetitionContextProvider>
              <CategoriesList mode="final-results" />
            </CompetitionContextProvider>
          ),
        },
        {
          path: ":competitionId/categories/:categoryId/rounds",
          element: (
            <CompetitionContextProvider>
              <CategoryContextProvider>
                <RoundsList />
              </CategoryContextProvider>
            </CompetitionContextProvider>
          ),
        },
        {
          path: ":competitionId/final-results/:categoryId",
          element: (
            <CompetitionContextProvider>
              <CategoryContextProvider>
                <FinalResultsView />
              </CategoryContextProvider>
            </CompetitionContextProvider>
          ),
        },
        {
          path: ":competitionId/categories/:categoryId/rounds/:roundId",
          element: (
            <CompetitionContextProvider>
              <CategoryContextProvider>
                <RoundContextProvider>
                  <ResultsView />
                </RoundContextProvider>
              </CategoryContextProvider>
            </CompetitionContextProvider>
          ),
        },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  } as any,
);

function AppContent() {
  const { darkMode } = useTheme();
  const theme = Theme(darkMode);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </MuiThemeProvider>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}
